import { render, staticRenderFns } from "./BlessingCommissionReport.vue?vue&type=template&id=7c2645b6&"
import script from "./BlessingCommissionReport.vue?vue&type=script&lang=js&"
export * from "./BlessingCommissionReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports